import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const currentYear = new Date().getFullYear();
  return <>
      <footer className="relative w-full bg-[#0a0f1a] border-t border-white/[0.05] py-8 px-6 md:px-12 z-20" data-id="element-4">
        {/* Subtle top gradient line */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-[1px] bg-gradient-to-r from-transparent via-teal-500/20 to-transparent" data-id="element-5" />

        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-6">
          <div className="text-gray-500 font-mono text-xs tracking-widest uppercase" data-id="element-7">
            &copy; {currentYear} The Sentinel Protocol. All rights reserved.
          </div>

          <div className="flex items-center gap-6" data-id="element-8">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-teal-400 font-mono text-xs tracking-widest uppercase transition-colors" data-id="element-9">
              Privacy Policy
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-teal-400 font-mono text-xs tracking-widest uppercase transition-colors" data-id="element-10">
              Terms of Service
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Privacy Policy" data-id="element-11">
        <section data-id="element-12">
          <h3 className="text-white font-semibold mb-2" data-id="element-13">
            1. Information Collection
          </h3>
          <p className="text-sm" data-id="element-14">
            We collect information you provide directly to us when you make a
            purchase, sign up for our newsletter, or communicate with us. This
            may include your name, email address, and payment information.
          </p>
        </section>
        <section data-id="element-15">
          <h3 className="text-white font-semibold mb-2" data-id="element-16">
            2. Use of Information
          </h3>
          <p className="text-sm" data-id="element-17">
            We use the information we collect to deliver the products you
            purchased, send you technical notices, updates, security alerts, and
            support messages.
          </p>
        </section>
        <section data-id="element-18">
          <h3 className="text-white font-semibold mb-2" data-id="element-19">3. Data Security</h3>
          <p className="text-sm" data-id="element-20">
            We take reasonable measures to help protect information about you
            from loss, theft, misuse and unauthorized access, disclosure,
            alteration and destruction. All payment transactions are encrypted
            and processed through secure third-party gateways.
          </p>
        </section>
        <section data-id="element-21">
          <h3 className="text-white font-semibold mb-2" data-id="element-22">
            4. Third-Party Services
          </h3>
          <p className="text-sm" data-id="element-23">
            We may share information with vendors, consultants, and other
            service providers who need access to such information to carry out
            work on our behalf (such as payment processing).
          </p>
        </section>
      </LegalModal>

      {/* Terms of Service Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Terms of Service" data-id="element-24">
        <section data-id="element-25">
          <h3 className="text-white font-semibold mb-2" data-id="element-26">
            1. Acceptance of Terms
          </h3>
          <p className="text-sm" data-id="element-27">
            By accessing and purchasing The Sentinel Protocol, you agree to be
            bound by these Terms of Service and all applicable laws and
            regulations.
          </p>
        </section>
        <section data-id="element-28">
          <h3 className="text-white font-semibold mb-2" data-id="element-29">
            2. Product Description
          </h3>
          <p className="text-sm" data-id="element-30">
            The Sentinel Protocol is a digital logistics and resilience manual.
            All content is provided for informational and educational purposes
            only. It does not constitute professional legal, medical, or
            security advice.
          </p>
        </section>
        <section data-id="element-31">
          <h3 className="text-white font-semibold mb-2" data-id="element-32">3. Payment Terms</h3>
          <p className="text-sm" data-id="element-33">
            All payments are processed securely. You agree to provide current,
            complete, and accurate purchase and account information for all
            purchases made.
          </p>
        </section>
        <section data-id="element-34">
          <h3 className="text-white font-semibold mb-2" data-id="element-35">4. Refund Policy</h3>
          <p className="text-sm" data-id="element-36">
            Due to the digital nature of the product, all sales are final once
            the digital content has been accessed or downloaded, unless
            otherwise required by consumer protection laws in your jurisdiction.
          </p>
        </section>
        <section data-id="element-37">
          <h3 className="text-white font-semibold mb-2" data-id="element-38">
            5. Limitation of Liability
          </h3>
          <p className="text-sm" data-id="element-39">
            In no event shall The Sentinel Protocol or its creators be liable
            for any damages arising out of the use or inability to use the
            materials provided in the manual.
          </p>
        </section>
      </LegalModal>
    </>;
}